// /src/mixins/resizeMixin.js

export default {
    data() {
        return {
            isMobile: false,
            isTablet: false,
            isTabletVertical: false,
            isDesktop: false,
            screen: {
                width: 0,
                height: 0,
            },
            breakPoints: {
                mobile: 760,
                desktop: 1100,
            },
        }
    },
    computed: {

    },

    methods: {
        checkResize() {
            const { breakPoints, screen } = this
            this.screen.width = window.innerWidth
            this.isMobile = screen.width <= breakPoints.mobile ? true : false
            this.isTablet = (screen.width > breakPoints.mobile && screen.width < breakPoints.desktop) ? true : false
            this.isDesktop = (screen.width >= breakPoints.desktop) ? true : false
        },
        debug() {
            const { isMobile, isTablet, isDesktop } = this
            return {
                isMobile,
                isTablet,
                isDesktop
            }
        }
      },
    mounted() {
        this.checkResize()
    },
    created() {
        window.addEventListener('resize', this.checkResize)
      },
    destroyed() {
        window.removeEventListener('resize', this.checkResize)
    },
}

